import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

export interface AuthState {
  devices: Array<Device>;
  token: string;
}

export interface Device {
  id: number;
  pharmacistId: number;
  alias: string;
  devieceId: string;
  firebaseToken: string;
}
const { persistAtom } = recoilPersist();

export const authState = atom({
  key: 'auth',
  default: {},
  effects_UNSTABLE: [persistAtom]
});
